/**
 * The client half of the server's email plausibility rule (KEY-423) — see `EmailAddress.IsPlausible`
 * in the API, which is the enforcement; this exists so a form can refuse `betty@@boober.com` before
 * the round-trip instead of after it. Keep the two in step: exactly one @, something before it, a
 * dotted domain that doesn't end on the dot, no whitespace, and at most 320 characters.
 */
export function isPlausibleEmail(email: string): boolean {
  const t = email.trim();
  if (t.length === 0 || t.length > 320 || /\s/.test(t)) return false;
  const at = t.indexOf("@");
  if (at <= 0 || at !== t.lastIndexOf("@")) return false;
  const domain = t.slice(at + 1);
  return domain.indexOf(".") > 0 && !domain.endsWith(".");
}
